import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { putRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import { ConnectorContext } from '../context/context'
import SelectInput from '../../../common/SelectInput'

const CONNECTOR_CATEGORY_NAMES = {
  inline: 'Inline',
  splice: 'Splice',
  fuse: 'Fuse',
  module: 'Module',
  joint: 'Joint',
  high_voltage: 'High Voltage',
  ground: 'Ground',
  not_electrical: 'Not Electrical',
  power_distribution: 'Power Distribution',
  connector: 'Connector',
}

const CONNECTOR_CATEGORY_OPTIONS = [
  { value: 'inline', label: CONNECTOR_CATEGORY_NAMES.inline },
  { value: 'splice', label: CONNECTOR_CATEGORY_NAMES.splice },
  { value: 'fuse', label: CONNECTOR_CATEGORY_NAMES.fuse },
  { value: 'module', label: CONNECTOR_CATEGORY_NAMES.module },
  { value: 'joint', label: CONNECTOR_CATEGORY_NAMES.joint },
  { value: 'high_voltage', label: CONNECTOR_CATEGORY_NAMES.high_voltage },
  { value: 'ground', label: CONNECTOR_CATEGORY_NAMES.ground },
  { value: 'not_electrical', label: CONNECTOR_CATEGORY_NAMES.not_electrical },
  {
    value: 'power_distribution',
    label: CONNECTOR_CATEGORY_NAMES.power_distribution,
  },
  { value: 'connector', label: CONNECTOR_CATEGORY_NAMES.connector },
]

const ConnectorForm = (props) => {
  const [connectorDetails, setConnectorDetails] = useState({})
  const [value, dispatch] = useContext(NavContext)
  const [connectorState, connectorDispatch] = useContext(ConnectorContext)

  useEffect(() => {
    if (connectorState?.selectedConnector?.id) {
      setConnectorDetails(connectorState.selectedConnector)
    }
  }, [connectorState?.selectedConnector])

  const saveConnectorDetails = async () => {
    let res = await putRequest(
      `/api/connector/save_connector/${connectorDetails.id}/`,
      connectorDetails
    )
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: `Connector saved successfully`,
      },
    })

    connectorDispatch({
      type: 'update_change_connector',
      data: connectorDetails,
    })
    props.onSave()
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveConnectorDetails(e)
        }}
      >
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="description"
              type="text"
              label="Description"
              value={connectorDetails.description}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, description: value })
              }}
            />
          </div>
          <div className="w-1/2">
            <SelectInput
              options={CONNECTOR_CATEGORY_OPTIONS}
              value={{
                label: CONNECTOR_CATEGORY_NAMES[connectorDetails.category],
                value: connectorDetails.category,
              }}
              name="category"
              label="Category"
              onChange={(value) => {
                setConnectorDetails({
                  ...connectorDetails,
                  category: value.value,
                })
              }}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="cavities"
              type="text"
              label="Cavities"
              value={connectorDetails.cavities}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, cavities: value })
              }}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="icon"
              type="text"
              label="Icon"
              value={connectorDetails.icon}
              isRequired={false}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, icon: value })
              }}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4 mr-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save Connector'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

ConnectorForm.propTypes = {
  onSave: PropTypes.func.isRequired,
}

export default ConnectorForm
